import { routes, type RouteName } from '@shared/constants/routes'
import { useMemo } from 'react'
import { getObjectKeys, getObjectFromEntries } from '@/features/shared/utils/types'
import { useCurrentRouteData } from '@/features/shared/hooks/routes/useCurrentRouteData'

export const useIsPage = () => {
  const routeData = useCurrentRouteData()

  return useMemo<Record<RouteName, boolean>>(() => {
    return getObjectFromEntries(
      getObjectKeys(routes).map((routeName) => [routeName, routeName === routeData?.routeName]),
    )
  }, [routeData?.routeName])
}

export const useIsOneOfPages = (routeNamesArray: RouteName[]) => {
  const isPageObject = useIsPage()

  return useMemo(() => {
    return routeNamesArray.some((routeName) => isPageObject[routeName])
  }, [isPageObject, routeNamesArray])
}
